import { Capacitor } from "@capacitor/core";
import { convertToJpeg } from "@/utils/imageToJpeg";

export async function readDamageControlPhoto(photo, deps = {}) {
  const fetchImpl = deps.fetchImpl || fetch;
  const rawPath = photo && (photo.webPath || photo.path);
  if (!rawPath) throw new Error("camera_photo_missing_path");
  const path = photo.webPath ? rawPath : (deps.convertFileSrc || Capacitor.convertFileSrc || ((value) => value))(rawPath);
  const response = await fetchImpl(path);
  if (response.ok === false) throw new Error("camera_photo_fetch_failed");
  let blob = await response.blob();
  const format = String(photo.format || "").toLowerCase();
  if (!blob.type && ["jpeg", "jpg", "heic", "heif"].includes(format)) {
    blob = new Blob([blob], { type: `image/${format === "jpg" ? "jpeg" : format}` });
  }
  if (/^image\/(heic|heif)$/i.test(blob.type) || /^(heic|heif)$/i.test(format) || /\.(heic|heif)(?:$|[?#])/i.test(path)) {
    const converted = await (deps.convertToJpeg || convertToJpeg)(blob, { quality: 0.95 }, deps.imageDeps || {});
    if (!converted || !converted.file) throw new Error("camera_heic_conversion_failed");
    blob = converted.file;
  }
  if (blob.type !== "image/jpeg") throw new Error("camera_expected_jpeg");
  return blob;
}
